import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute = ({ children, requireTos = true, requireVerified = true, requireMfa = true }) => {
    const { user, userProfile, emailVerified, isAdmin, isFacilityAdmin, mfaEnrolled } = useAuth();

    if (!user) {
        return <Navigate to="/login" />;
    }

    // C1: the backend rejects unverified accounts with 403 email_unverified.
    // Catch it here so the user lands on a page that can fix it.
    // `emailVerified` comes from AuthContext's onIdTokenChanged listener, so
    // the forced token refresh after verification updates it explicitly.
    // Strict `=== false` so `null` (not yet known) is not redirected.
    if (requireVerified && emailVerified === false) {
        return <Navigate to="/verify-email" />;
    }

    // If ToS is required, profile exists, and ToS not accepted → redirect
    if (requireTos && userProfile && !userProfile.tos_accepted_at) {
        return <Navigate to="/accept-tos" />;
    }

    // C2: site and facility admins must hold a second factor. Sits after the
    // ToS check so a new facility admin reads the terms first. Strict
    // `=== false` so `null` (not yet known) does not block.
    if (requireMfa && (isAdmin || isFacilityAdmin) && mfaEnrolled === false) {
        return <Navigate to="/mfa-setup" />;
    }

    return children;
};
